function Text(texts) {

    this.name = 'text';

    this.texts = texts;
}

export {Text};
